export enum ScanType {
  EXTRACTION_BATCH = 'extracted-batch',
  SEQUENCING_BATCH = 'sequencing-batch',
}
